import { gql } from 'graphql-request'

export const GET_WRITERS_SALES_SUMMARY = gql`
  query GetWriterSalesSummary(
    $getWriterSalesSummaryInput: GetWriterSalesSummaryInput!
  ) {
    getWriterSalesSummary(
      getWriterSalesSummaryInput: $getWriterSalesSummaryInput
    ) {
      writerId
      totalWriterIncome
      novelChapterSalesSummary
      mangaChapterSalesSummary
      novelEbookSalesSummary
      mangaEbookSalesSummary
      donationSummary
      totalWriterIncomeCumulative
    }
  }
`
